export const SET_RECORD_DETAILS = 'SET_RECORD_DETAILS'
export const SET_RENDERINGS = 'SET_RENDERINGS'
export const SET_RECORD_HISTORY = 'SET_RECORD_HISTORY'
export const SET_RECORD_HISTORY_LIST = 'SET_RECORD_HISTORY_LIST'
export const SET_TRADEMARK_HISTORY = 'SET_TRADEMARK_HISTORY'
export const SET_RECORD_NOTES = 'SET_RECORD_NOTES'
export const SET_RECORD_EVENTS = 'SET_RECORD_EVENTS'
export const SET_RECORD_CORRESPONDENCE = 'SET_RECORD_CORRESPONDENCE'
export const SET_ENUM_CATEGORY = 'SET_ENUM_CATEGORY'
export const SET_UCC_AMENDMENT = 'SET_UCC_AMENDMENT'
export const SET_UCC_HISTORY = 'SET_UCC_HISTORY'
export const CLEAR_UCC_DATA = 'CLEAR_UCC_DATA'
export const SET_AMENDMENT_HISTORY = 'SET_AMENDMENT_HISTORY'
export const CLEAR_WEB_USER_DATA = 'CLEAR_WEB_USER_DATA'
export const SET_USER_RIGHTS_OPTIONS = 'SET_USER_RIGHTS_OPTIONS'
export const UPDATE_WEB_USER_RIGHT = 'UPDATE_WEB_USER_RIGHT'
export const UPDATE_WEB_USER_FREQUENT_PAYOR = 'UPDATE_WEB_USER_FREQUENT_PAYOR'
export const SET_FREQUENT_PAYOR_INFO = 'SET_FREQUENT_PAYOR_INFO'
export const SET_FREQUENT_PAYOR_TRANSACTIONS = 'SET_FREQUENT_PAYOR_TRANSACTIONS'
export const SET_FREQUENT_PAYOR_COMMENTS = 'SET_FREQUENT_PAYOR_COMMENTS'
export const SET_FREQUENT_PAYOR_ACCOUNTS = 'SET_FREQUENT_PAYOR_ACCOUNTS'
export const CLEAR_UCC_INFO_REQUEST = 'CLEAR_UCC_INFO_REQUEST'
export const CLEAR_RECORD_DATA = 'CLEAR_RECORD_DATA'
export const SET_SELECTED_HISTORY_RECORD = 'SET_SELECTED_HISTORY_RECORD'
export const SET_TEMP_NUM = 'SET_TEMP_NUM'
export const UPDATE_PARTY_GRID = 'UPDATE_PARTY_GRID'
export const SET_NOTARY_RECORD_DETAILS_SETTINGS = 'SET_NOTARY_RECORD_DETAILS_SETTINGS'
export const SET_EXPANDABLE_HISTORY = 'SET_EXPANDABLE_HISTORY'
export const SET_SELECTED_NOTARY_COMPLAINT = 'SET_SELECTED_NOTARY_COMPLAINT'
export const SET_SELECTED_CONTRACTOR_COMPLAINT = 'SET_SELECTED_CONTRACTOR_COMPLAINT'

const initialState = {
  recordDetails: {},
  rendering: {},
  recordAmendmentHistory: [],
  recordCorrespondenceAmendments: [],
  recordHistoryList: [],
  selectedHistoryRecord: {},
  recordNotes: [],
  recordEvents: [],
  recordCorrespondence: [],
  idEnums: {},
  fullArrayEnums: {},
  ucc: {},
  uccHistory: {},
  webUserRightsOptions: [],
  frequentPayor: {},
  frequentPayorTransactions: [],
  frequentPayorComments: '',
  frequentPayorAccounts: [],
  tempNum: '',
  notaryRecordDetailsSettings: {},
  expandableHistory: {
    amendments: [],
    history: [],
    template: [],
  },
  selectedNotaryComplaint: {},
  selectedContractorComplaint: {},
}

const RecordReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RECORD_DETAILS: {
      return {
        ...state,
        recordDetails: action.record,
      }
    }
    case SET_RENDERINGS: {
      return {
        ...state,
        rendering: action.rendering,
      }
    }
    case SET_AMENDMENT_HISTORY: {
      // console.log(action);
      return {
        ...state,
        recordAmendmentHistory: action.history,
      }
    }
    case SET_RECORD_HISTORY: {
      return {
        ...state,
        recordAmendmentHistory: action.history.amendments,
        recordCorrespondenceAmendments: action.history.corrspondenceAmendments,
        recordHistoryList: action.history.historyList,
      }
    }
    case SET_TRADEMARK_HISTORY: {
      return {
        ...state,
        trademarkHistory: action.history,
        recordAmendmentHistory: action.history.AmendmentList,
        recordHistoryList: action.history.HistoryList,
      }
    }
    case SET_RECORD_NOTES: {
      return {
        ...state,
        recordNotes: action.notes,
      }
    }
    case SET_RECORD_EVENTS: {
      return {
        ...state,
        recordEvents: [{ test: 'test' }], //action.events
      }
    }
    case SET_RECORD_CORRESPONDENCE: {
      return {
        ...state,
        //action.correspondence
        recordCorrespondence: [
          {
            CORRESPONDENCE_NAME: 'TEST Name',
            CORRESPONDENCE_ID: 3,
            CORRESPONDENCE_DATE: new Date(),
          },
        ], //action.correspondence
      }
    }
    case SET_ENUM_CATEGORY: {
      let idEnum = {}
      switch (action.category) {
        case 'UCC_AMENDMENT_TYPE_IDS':
          action.categoryEnum.map((item) => {
            idEnum[item.AmendmentType] = item.AmendmentTypeID
            return null
          })
          break
        case 'UCC_AMENDMENT_ACTION_TYPE_IDS':
          action.categoryEnum.map((item) => {
            idEnum[item.AmendmentActionType] = item.AmendmentActionTypeID
            return null
          })
          break
        case 'UCC_PARTY_ACTION_IDS':
          action.categoryEnum.map((item) => {
            idEnum[item.PartyActionType] = item.PartyActionTypeID
            return null
          })
          break
        default:
          action.categoryEnum.map((item) => {
            idEnum[item.Descr] = item.Type_ID
            return null
          })
      }
      return {
        ...state,
        idEnums: {
          ...state.idEnums,
          [action.category]: Object.freeze(idEnum),
        },
        fullArrayEnums: {
          ...state.fullArrayEnums,
          [action.category]: Object.freeze(action.categoryEnum),
        },
      }
    }
    case SET_UCC_AMENDMENT: {
      return {
        ...state,
        ucc: action.ucc,
      }
    }
    case SET_UCC_HISTORY: {
      return {
        ...state,
        uccHistory: action.data,
      }
    }
    case CLEAR_UCC_DATA: {
      return {
        ...state,
        uccHistory: [],
        ucc: {},
        recordNotes: [],
      }
    }
    case CLEAR_WEB_USER_DATA: {
      return {
        ...state,
        recordDetails: {},
      }
    }
    case SET_USER_RIGHTS_OPTIONS: {
      return {
        ...state,
        webUserRightsOptions: action.data,
      }
    }
    case UPDATE_WEB_USER_RIGHT: {
      let rightIds = state.recordDetails.RightIDs
      const index = rightIds.indexOf(action.id)
      if (index > -1) rightIds.splice(index, 1)
      else rightIds.push(action.id)
      return {
        ...state,
        recordDetails: {
          ...state.recordDetails,
          RightIDs: rightIds.sort(),
        },
      }
    }
    case UPDATE_WEB_USER_FREQUENT_PAYOR: {
      return {
        ...state,
        recordDetails: {
          ...state.recordDetails,
          FrequentPayorAccount: action.payor ? action.payor : null,
        },
      }
    }
    case SET_FREQUENT_PAYOR_INFO: {
      return {
        ...state,
        frequentPayor: action.data,
      }
    }
    case SET_FREQUENT_PAYOR_TRANSACTIONS: {
      return {
        ...state,
        frequentPayorTransactions: action.data,
      }
    }
    case SET_FREQUENT_PAYOR_COMMENTS: {
      return {
        ...state,
        frequentPayorComments: action.data,
      }
    }
    case SET_FREQUENT_PAYOR_ACCOUNTS: {
      return {
        ...state,
        frequentPayorAccounts: action.data,
      }
    }
    case CLEAR_UCC_INFO_REQUEST: {
      return {
        ...state,
        recordDetails: initialState.recordDetails,
        recordNotes: initialState.recordNotes,
      }
    }
    case SET_SELECTED_HISTORY_RECORD: {
      return {
        ...state,
        selectedHistoryRecord: action.selectedHistoryRecord,
      }
    }
    case CLEAR_RECORD_DATA: {
      return initialState
    }
    case SET_TEMP_NUM: {
      return {
        ...state,
        tempNum: action.tempNum,
      }
    }
    case UPDATE_PARTY_GRID: {
      return {
        ...state,
        recordDetails: {
          ...state.recordDetails,
          [`Party Grid ${action.listNumber}`]: action.updatedPartyGrid,
        },
      }
    }
    case SET_RECORD_HISTORY_LIST: {
      return {
        ...state,
        recordHistoryList: action.history,
      }
    }
    case SET_NOTARY_RECORD_DETAILS_SETTINGS: {
      return { ...state, notaryRecordDetailsSettings: action.notaryRecordDetailsSettings }
    }
    case SET_EXPANDABLE_HISTORY: {
      const { history } = action
      return {
        ...state,
        expandableHistory: {
          amendments: history.AMENDMENT_LIST,
          history: history.HISTORY_LIST,
          template: history.TEMPLATE,
        },
      }
    }
    case SET_SELECTED_NOTARY_COMPLAINT: {
      return {
        ...state,
        selectedNotaryComplaint: action.selectedNotaryComplaint,
      }
    }
    case SET_SELECTED_CONTRACTOR_COMPLAINT: {
      return {
        ...state,
        selectedContractorComplaint: action.selectedContractorComplaint,
      }
    }
    default:
      return state
  }
}

export default RecordReducer
